import { render, staticRenderFns } from "./coverage-bar.vue?vue&type=template&id=04d49fe7&scoped=true&"
import script from "./coverage-bar.vue?vue&type=script&lang=ts&"
export * from "./coverage-bar.vue?vue&type=script&lang=ts&"
import style0 from "./coverage-bar.vue?vue&type=style&index=0&id=04d49fe7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04d49fe7",
  null
  
)

export default component.exports